import React from 'react';
// [TODO] - Should take target children props as parameter
// [TODO] - Have more options for return values
//  [firstChild, childrenCollection, restChildren, beforeChildren, afterChildren]
/** Util */
export const findChildren = (targetComponent, children) => {
    let targetFound = false;
    return React.Children
        .toArray(children)
        .reduce((acc, child) => {
        if (child?.type.displayName === targetComponent.displayName) {
            targetFound = true;
            acc[0].push(child);
        }
        else if (!targetFound) {
            acc[1].push(child);
        }
        else {
            acc[2].push(child);
        }
        return acc;
    }, [[], [], []]);
};
export default findChildren;
//# sourceMappingURL=findChildren.js.map